// tslint:disable
/**
 * Property Management
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { CreateRoomZoneRequest } from '../models';
import { GetRoomListResponse } from '../models';
import { GetRoomZoneItemResponse } from '../models';
import { GetRoomZoneListResponse } from '../models';
import { UpdateRoomZoneRequest } from '../models';
/**
 * RoomZoneApi - axios parameter creator
 * @export
 */
export const RoomZoneApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} propertyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyIdRoomzoneGet(propertyId: string, options: any = {}): RequestArgs {
      // verify required parameter 'propertyId' is not null or undefined
      if (propertyId === null || propertyId === undefined) {
        throw new RequiredError(
          'propertyId',
          'Required parameter propertyId was null or undefined when calling propertyIdRoomzoneGet.'
        );
      }
      const localVarPath = `/{propertyId}/roomzone`.replace(
        `{${'propertyId'}}`,
        encodeURIComponent(String(propertyId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {string} propertyId
     * @param {CreateRoomZoneRequest} [createRoomZoneRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyIdRoomzoneIdPut(
      id: string,
      propertyId: string,
      createRoomZoneRequest?: CreateRoomZoneRequest,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling propertyIdRoomzoneIdPut.'
        );
      }
      // verify required parameter 'propertyId' is not null or undefined
      if (propertyId === null || propertyId === undefined) {
        throw new RequiredError(
          'propertyId',
          'Required parameter propertyId was null or undefined when calling propertyIdRoomzoneIdPut.'
        );
      }
      const localVarPath = `/{propertyId}/roomzone/{id}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'propertyId'}}`, encodeURIComponent(String(propertyId)));
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof createRoomZoneRequest !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(createRoomZoneRequest !== undefined ? createRoomZoneRequest : {})
        : createRoomZoneRequest || '';

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {string} propertyId
     * @param {UpdateRoomZoneRequest} [updateRoomZoneRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyIdRoomzoneIdRoomsPost(
      id: string,
      propertyId: string,
      updateRoomZoneRequest?: UpdateRoomZoneRequest,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling propertyIdRoomzoneIdRoomsPost.'
        );
      }
      // verify required parameter 'propertyId' is not null or undefined
      if (propertyId === null || propertyId === undefined) {
        throw new RequiredError(
          'propertyId',
          'Required parameter propertyId was null or undefined when calling propertyIdRoomzoneIdRoomsPost.'
        );
      }
      const localVarPath = `/{propertyId}/roomzone/{id}/rooms`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'propertyId'}}`, encodeURIComponent(String(propertyId)));
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof updateRoomZoneRequest !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(updateRoomZoneRequest !== undefined ? updateRoomZoneRequest : {})
        : updateRoomZoneRequest || '';

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * RoomZoneApi - functional programming interface
 * @export
 */
export const RoomZoneApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} propertyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyIdRoomzoneGet(
      propertyId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRoomZoneListResponse> {
      const localVarAxiosArgs = RoomZoneApiAxiosParamCreator(configuration).propertyIdRoomzoneGet(
        propertyId,
        options
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {string} id
     * @param {string} propertyId
     * @param {CreateRoomZoneRequest} [createRoomZoneRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyIdRoomzoneIdPut(
      id: string,
      propertyId: string,
      createRoomZoneRequest?: CreateRoomZoneRequest,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRoomZoneItemResponse> {
      const localVarAxiosArgs = RoomZoneApiAxiosParamCreator(configuration).propertyIdRoomzoneIdPut(
        id,
        propertyId,
        createRoomZoneRequest,
        options
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {string} id
     * @param {string} propertyId
     * @param {UpdateRoomZoneRequest} [updateRoomZoneRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyIdRoomzoneIdRoomsPost(
      id: string,
      propertyId: string,
      updateRoomZoneRequest?: UpdateRoomZoneRequest,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRoomListResponse> {
      const localVarAxiosArgs = RoomZoneApiAxiosParamCreator(
        configuration
      ).propertyIdRoomzoneIdRoomsPost(id, propertyId, updateRoomZoneRequest, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * RoomZoneApi - factory interface
 * @export
 */
export const RoomZoneApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @param {string} propertyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyIdRoomzoneGet(
      propertyId: string,
      options?: any
    ): AxiosPromise<GetRoomZoneListResponse> {
      return RoomZoneApiFp(configuration).propertyIdRoomzoneGet(propertyId, options)(
        axios,
        basePath
      );
    },
    /**
     *
     * @param {string} id
     * @param {string} propertyId
     * @param {CreateRoomZoneRequest} [createRoomZoneRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyIdRoomzoneIdPut(
      id: string,
      propertyId: string,
      createRoomZoneRequest?: CreateRoomZoneRequest,
      options?: any
    ): AxiosPromise<GetRoomZoneItemResponse> {
      return RoomZoneApiFp(configuration).propertyIdRoomzoneIdPut(
        id,
        propertyId,
        createRoomZoneRequest,
        options
      )(axios, basePath);
    },
    /**
     *
     * @param {string} id
     * @param {string} propertyId
     * @param {UpdateRoomZoneRequest} [updateRoomZoneRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyIdRoomzoneIdRoomsPost(
      id: string,
      propertyId: string,
      updateRoomZoneRequest?: UpdateRoomZoneRequest,
      options?: any
    ): AxiosPromise<GetRoomListResponse> {
      return RoomZoneApiFp(configuration).propertyIdRoomzoneIdRoomsPost(
        id,
        propertyId,
        updateRoomZoneRequest,
        options
      )(axios, basePath);
    },
  };
};

/**
 * RoomZoneApi - object-oriented interface
 * @export
 * @class RoomZoneApi
 * @extends {BaseAPI}
 */
export class RoomZoneApi extends BaseAPI {
  /**
   *
   * @param {string} propertyId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RoomZoneApi
   */
  public propertyIdRoomzoneGet(propertyId: string, options?: any) {
    return RoomZoneApiFp(this.configuration).propertyIdRoomzoneGet(propertyId, options)(
      this.axios,
      this.basePath
    );
  }

  /**
   *
   * @param {string} id
   * @param {string} propertyId
   * @param {CreateRoomZoneRequest} [createRoomZoneRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RoomZoneApi
   */
  public propertyIdRoomzoneIdPut(
    id: string,
    propertyId: string,
    createRoomZoneRequest?: CreateRoomZoneRequest,
    options?: any
  ) {
    return RoomZoneApiFp(this.configuration).propertyIdRoomzoneIdPut(
      id,
      propertyId,
      createRoomZoneRequest,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @param {string} id
   * @param {string} propertyId
   * @param {UpdateRoomZoneRequest} [updateRoomZoneRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RoomZoneApi
   */
  public propertyIdRoomzoneIdRoomsPost(
    id: string,
    propertyId: string,
    updateRoomZoneRequest?: UpdateRoomZoneRequest,
    options?: any
  ) {
    return RoomZoneApiFp(this.configuration).propertyIdRoomzoneIdRoomsPost(
      id,
      propertyId,
      updateRoomZoneRequest,
      options
    )(this.axios, this.basePath);
  }
}
